export default __webpack_public_path__ + "static/media/tele.f8ed0975.png";